/*
 * @Author: cyx
 * @Date: 2021-04-08 19:52:37
 * @LastEditors: cyx
 * @LastEditTime: 2021-04-13 19:11:59
 * @Description: file content
 */

import request from 'umi-request'
import {
  compressSync,
  strFromU8,
  strToU8,
  decompressSync,
  deflateSync,
  zlibSync
} from 'fflate'
import { getEnv } from '@/utils/utils'
// import { isProductionEnv } from '@/utils/env';

const domains = {
  '3.5': {
    dev: 'https://test-data35-nexus-server.stardustgod.com',
    test: 'https://test-data35-nexus-server.stardustgod.com',
    prod: 'https://analysis-an.stardustgod.com',
    gray: 'https://analysis-an.stardustgod.com'
  }
}
console.log('process.env.NODE_ENV', getEnv())
const URL = domains['3.5'][getEnv()]

export async function reportInfo(params: any) {
  // if (getEnv() === 'dev') return
  // 开发环境不上报
  // console.log('上报的数据是。。。。', params.list);

  const realParams = {
    ...params,
    list: JSON.stringify(params.list)
  }

  const binData = strToU8(JSON.stringify(realParams), true)

  const compressedData = zlibSync(binData, {})

  const compressedString = strFromU8(compressedData, true)

  // smart -> feedbackh5用了md5  -> 但是kiss不用md5 -> 保留下吧
  // const md5End = md5(string1) + string1;
  // console.log(
  //   '🚀 ~ file: reportInfoServices.ts ~ line 25 ~ reportInfo ~ md5End',
  //   md5End,
  // );
  const base64 = window.btoa(compressedString)
  return request(`${URL}/v3/KissAdb.php`, {
    method: 'post',
    headers: {
      PLATFORM: 'ios'
    },
    data: base64
  })
    .then((response: any) => ({ response, error: null }))
    .catch((error: any) => ({ error, response: null }))
}

/**
 * @description: 3.5上报响应解码
 * @param {*}
 * @return {*}
 */
export const decodeReportResponse = (str: string) => {
  let str1
  try {
    str1 = window.atob(str)
    const charData = str1.split('').map(function (x) {
      return x.charCodeAt(0)
    })

    const binData = new Uint8Array(charData)
    const decompressed = decompressSync(binData)

    const response = strFromU8(decompressed)
    return response
  } catch (error) {
    return ''
  }
}

// if (!isProductionEnv) {
//   window.decode = (res) => JSON.parse(decodeReportResponse(res));
// }
